"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppConfig = exports.appConfigContextDefaultValue = exports.appConfigContext = exports.AppConfigProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const appConfigContextDefaultValue = exports.appConfigContextDefaultValue = {
  setSessionId: () => {}
};
const appConfigContext = exports.appConfigContext = /*#__PURE__*/(0, _react.createContext)(appConfigContextDefaultValue);
const AppConfigProvider = ({
  children,
  value: props
}) => {
  const [sessionId, setSessionId] = (0, _react.useState)();
  const value = (0, _react.useMemo)(() => ({
    ...props,
    sessionId,
    setSessionId
  }), [props, sessionId, setSessionId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(appConfigContext.Provider, {
    value: value,
    children: children
  });
};
exports.AppConfigProvider = AppConfigProvider;
const useAppConfig = () => (0, _react.useContext)(appConfigContext);
exports.useAppConfig = useAppConfig;